var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedInDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "symbol",
    stroke: "none",
    d: "M31 8H9C8.4 8 8 8.4 8 9V31C8 31.6 8.4 32 9 32H31C31.6 32 32 31.6 32 31V9C32 8.4 31.6 8 31 8ZM15.1 28.5H11.6V17H15.2V28.5H15.1ZM13.3 15.4C12.2 15.4 11.2 14.5 11.2 13.3C11.2 12.2 12.1 11.2 13.3 11.2C14.4 11.2 15.4 12.1 15.4 13.3C15.4 14.5 14.5 15.4 13.3 15.4ZM28.5 28.5H24.9V22.9C24.9 21.6 24.9 19.9 23.1 19.9C21.2 19.9 21 21.3 21 22.8V28.5H17.4V17H20.8V18.6C21.3 17.7 22.4 16.8 24.2 16.8C27.8 16.8 28.5 19.2 28.5 22.3V28.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInDefault);
export default __webpack_public_path__ + "static/media/LinkedIn_Default.4eac7d3d.svg";
export { ForwardRef as ReactComponent };